import template from './index.html.twig';
import './index.scss';

Shopware.Component.register('sw-cms-el-moorl-hero-banner', {
    template,

    mixins: [Shopware.Mixin.getByName('cms-element')],

    computed: {
        assetFilter() {
            return Shopware.Filter.getByName('asset');
        },

        captionCss() {
            const css = { color: this.element.config.boxColor.value };

            if (this.element.config.textShadowActive.value) {
                css.textShadow = '2px 2px 15px #000';
            }

            return css;
        },

        mediaUrl() {
            const elemData = this.element.data.media;
            const mediaSource = this.element.config.media.source;

            if (mediaSource === 'mapped') {
                const demoMedia = this.getDemoValue(
                    this.element.config.media.value
                );

                if (demoMedia && demoMedia.url) {
                    return demoMedia.url;
                }

                return this.assetFilter(
                    'administration/administration/static/img/cms/preview_mountain_large.jpg'
                );
            }

            if (elemData && elemData.id) {
                return this.element.data.media.url;
            }

            if (elemData && elemData.url) {
                return this.assetFilter(elemData.url);
            }

            return this.assetFilter(
                'administration/administration/static/img/cms/preview_mountain_large.jpg'
            );
        },
    },

    watch: {
        cmsPageState: {
            deep: true,
            handler() {
                this.$forceUpdate();
            },
        },

        mediaConfigValue(value) {
            const mediaId = Utils.get(this.element, 'data.media.id');
            const isSourceStatic =
                Utils.get(this.element, 'config.media.source') === 'static';

            if (isSourceStatic && mediaId && value !== mediaId) {
                this.element.config.media.value = mediaId;
            }
        },
    },

    created() {
        this.createdComponent();
    },

    methods: {
        createdComponent() {
            this.initElementConfig('moorl-hero-banner');
            this.initElementData('moorl-hero-banner');
        },
    },
});
